<template>
    <component @show="$emit('show', $event)" :is="headerComponentName" @change-profile="changeProfile()"></component>
</template>

<script>
import HeaderBlank from '@/layouts/header/blank';
import HeaderSupplier from '@/layouts/header/supplier';
import HeaderSupplierGuest from '@/layouts/header/supplier/guest';
import HeaderGuestContractor from '@/layouts/header/contractor/guest';
import HeaderContractor from '@/layouts/header/contractor';
import HeaderCondotechs from '@/layouts/header/condotechs';

import { mapActions } from 'vuex';

export default {
    name: 'HeaderIndex',
    components: {
        HeaderBlank,
        HeaderSupplier,
        HeaderContractor,
        HeaderSupplierGuest,
        HeaderGuestContractor,
        HeaderCondotechs
    },
    methods: {
        ...mapActions('signup', ['setSignupType']),
        changeProfile() {
            this.setSignupType('');
            this.$router.push('/inicio');
        }
    },
    props: {
        'header-type': {
            type: String,
            default: 'blank'
        }
    },
    data: () => ({
        headerTypes: [
            { label: 'blank', component: HeaderBlank },
            { label: 'condo-administrator', component: HeaderBlank },
            { label: 'contractor', component: HeaderContractor },
            { label: 'condominum', component: HeaderContractor },
            { label: 'physical-person', component: HeaderContractor },
            { label: 'guest-contractor', component: HeaderGuestContractor },
            { label: 'requester', component: HeaderBlank },
            { label: 'supplier', component: HeaderSupplier },
            { label: 'guest-supplier', component: HeaderSupplierGuest },
            { label: 'condotechs', component: HeaderCondotechs }
        ]
    }),
    computed: {
        headerComponentName() {
            const headerType = this.headerTypes.find(headerType => headerType.label == this.headerType);
            if (headerType) {
                return headerType.component;
            } else if (this.headerType == 'none') {
                return false;
            } else {
                return this.headerTypes.find(headerType => headerType.label == 'blank');
            }
        }
    }
};
</script>

<style lang="scss">
</style>
